<ng-template #buttons>
    <app-button
        icon="pi-print"
        label="workData.printDialog.buttons.print"
        (clickEvent)="printRecords()"
    ></app-button>
</ng-template>

<app-table
    [tableTitle]="'service.operationalReport.title'"
    [columns]="filteredColumns()"
    translatePrefix="service.operationalReport."
    [buttons]="extendedWorkExportsEnabled ? buttons : null"
    [hideCheckboxes]="!extendedWorkExportsEnabled"
    [gridData]="$any(store.data.getWorks())"
    [additionalFilter]="additionalFilters()"
    [refreshCallback]="store.api.getWorks"
    [refreshCallbackFragment]="getWorksFrag"
    resource="operationalWork"
    (detailCallback)="goTo($event)"
    (createCallback)="goTo()"
    (deleteCallbackWithEvent)="deleteReport($event)"
    [defaultSorters]="[{ column: 'dateFrom', direction: 'DESC' }]"
>
    @if (extendedWorkExportsEnabled) {
        <ng-template pTemplate="link" let-item="item">
            <app-button
                styleClass="tableIcon"
                svgIcon="pdf"
                [text]="true"
                (clickEvent)="$event.stopPropagation(); printRecord(item)"
            ></app-button>
        </ng-template>
    }

    <ng-template pTemplate="form" let-data="data">
        {{ data ? ('service.serviceFormEnum.' + data | translate) : '' }}
    </ng-template>
    <ng-template pTemplate="type" let-data="data">
        {{ data ? ('service.operationalReport.type.' + data | translate) : '' }}
    </ng-template>
    <ng-template pTemplate="priority" let-data="data">
        {{ data ? ('service.operationalReport.priority.' + data | translate) : '' }}
    </ng-template>
    <ng-template pTemplate="users" let-data="data">
        <div class="flex flex-column gap-small">
            @for (user of data; track $index) {
                <app-user-chip
                    [user]="user"
                ></app-user-chip>
            }
        </div>
    </ng-template>
</app-table>
